import { useQuery } from "@tanstack/react-query";
import type { Moment } from "moment-timezone";
import type { WeeklyIncentiveData } from "../models/WeeklyIncentiveData";
import { getWeeklyIncentive } from "../repositories/IncentiveRepository";

export const useWeeklyIncentive = (weekEndingDate: Moment) => {
	const weekEndStr = weekEndingDate.format("YYYY-MM-DD");

	const query = useQuery<WeeklyIncentiveData, Error>({
		queryKey: ["incentive", weekEndStr],
		queryFn: ({ signal }) => getWeeklyIncentive(weekEndStr, signal),
		refetchInterval: 60_000,
		refetchOnWindowFocus: true,
	});

	return {
		data: query.data,
		isLoading: query.isLoading,
		error: query.error,
	};
};
